module.exports = "/fonts/vendor/@fontsource/roboto/files/roboto-vietnamese-300-normal.woff2?32fc45a3d1e8ea11fabc34cc5a93806f";